var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages && Array.isArray(_vm.messages) && _vm.messages.length > 0)?_c('div',{staticClass:"alert p-3",class:'alert-' + _vm.variant,staticStyle:{"text-align":"left"},attrs:{"show":""}},[_c('ul',_vm._l((_vm.messages),function(message,i){return _c('li',{key:i + '_' + message},[_vm._v(" "+_vm._s(message)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }